/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const { project } = feature;
    const MQTT_INTERFACE = 'current_interface';
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const MQTT_NAME = feature.getSettingValue('MQTT_NAME');
    const MQTT_PASSWORD = feature.getSettingValue('MQTT_PASSWORD');
    const MQTT_APP_CLIENT_ID = feature.getSettingValue('MQTT_APP_CLIENT_ID');
    const MQTT_SERVER_HOST = feature.getSettingValue('MQTT_SERVER_HOST');
    const MQTT_DESTINATION_PORT = feature.getSettingValue('MQTT_DESTINATION_PORT');
    const CERTIFICATEFILE = feature.getSettingValue('CERTIFICATEFILE');
    const TOPICS = feature.getSettingValue('TOPICS');


    if (CERTIFICATEFILE !== '') {
        blocks.push({
            location: 'GLOBAL_DEFINES',
            blockType: BlockType.CODE,
            template: `
#define MQTT_CER_FILE "${CERTIFICATEFILE.split('\n')[0]}"`,
        });
    }

    for (let i = 0; i < TOPICS.length; i++) {
        const topic = TOPICS[i];
        blocks = blocks.concat(topic.getCodeBlocks());
    }

    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const MQTT_TLS = ${feature.getSettingValue('MQTT_TLS')}
`,
    });

    blocks.push({
        location: project.getNetworkConnectedLocation(MQTT_INTERFACE),
        blockType: BlockType.CODE,
        template: `
mqtt_start(current_interface,${MQTT_SERVER_HOST},${MQTT_DESTINATION_PORT},${MQTT_NAME},${MQTT_PASSWORD},${MQTT_APP_CLIENT_ID},MQTT_TLS)`,
    });

    return blocks;
};
